import { render, staticRenderFns } from "./PromotionDetailPage.vue?vue&type=template&id=5907ee30"
import script from "./PromotionDetailPage.vue?vue&type=script&lang=js"
export * from "./PromotionDetailPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports